import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { ICompany } from 'bets.oddprovider.lib.common.ts/models'
import { IDefaultAction, IDefaultState } from 'fwork.react.apptemplate'
import { FilterQuery } from 'mongoose'
import axios from '../../apiClient/axios'
import { CompaniesApiClient } from '../../apiClient/companies'
import { IApiClientResult } from 'fwork-jsts-common/src/apiClient'
import { ApiResponseGetListData } from 'fwork-jsts-common/src/api'

export interface ICompaniesAction extends IDefaultAction {
  payload?: ICompany[],
}

export interface ICompaniesState extends IDefaultState {
  payload?: ICompany[],
}

const initState: ICompaniesState = {}

export const companiesStateLoadFromApi = createAsyncThunk(
  'companiesStateLoadFromApi',
  async (arg: {
    where?: FilterQuery<ICompany>,
    onSuccess?: () => void,
    onError?: (msg?: string) => void,
    onFinally?: () => void
  }) => {
    const apiResult: IApiClientResult<ApiResponseGetListData<ICompany>> = await new CompaniesApiClient(axios).get({
      where: arg.where,
      sort: { name: 1 }
    })

    if (apiResult.success) {
      if (arg.onSuccess)
        arg.onSuccess()
    }
    else if (arg.onError)
      arg.onError(apiResult.msg)

    if (arg.onFinally)
      arg.onFinally()
    return apiResult
  }
)

export const companiesSlice = createSlice({
  name: 'companiesSlice',
  initialState: initState,
  reducers: {
    clear: (state) => {
      state.payload = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(companiesStateLoadFromApi.pending, (state) => {
      if (!state.options)
        state.options = {}
      state.options.loading = true
    })
    builder.addCase(companiesStateLoadFromApi.fulfilled, (state, response) => {
      if (state.options)
        state.options.loading = false
      state.payload = response.payload.data?.payload
    })
    builder.addCase(companiesStateLoadFromApi.rejected, (state) => {
      if (state.options)
        state.options.loading = false
    })
  }
})

export const { clear: clearCompanies } = companiesSlice.actions
export default companiesSlice.reducer